export default "Slip fantasien og samarbejdet løs! Byg små huler og skab jeres egen lille jægerstenalderboplads.";